<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER -->
      <div class="header-row">
        <h2 class="page-title expenses-title">Xarajatlar</h2>

        <div class="header-right">
          <!-- Dollar Kursi -->
          <div class="rate-settings-container" ref="settingsContainer">
            <div class="rate-display" @click.stop="toggleSettings">
              <div class="dollar-circle">$</div>
              <span class="rate-value">{{ dollarRate | numFormat }}</span>
            </div>

            <transition name="slide-fade">
              <div v-if="showRateModal" class="mini-modal" @click.stop>
                <div class="modal-arrow"></div>
                <div class="modal-body">
                  <label class="modal-title">Yangi kursni kiriting</label>
                  <input type="number" v-model.number="newRate" placeholder="12 500..." @keyup.enter="updateDollarRate">
                  <button class="modal-save-btn" @click="updateDollarRate">
                    {{ isSaving ? 'Saqlanmoqda...' : 'SAQLASH' }}
                  </button>
                </div>
              </div>
            </transition>
          </div>

          <button class="settings-btn-top" @click="showSetting = true" title="Kategoriyalar">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="3"></circle>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
            </svg>
          </button>

          <button class="add-btn-top" @click="openCreate">
            + Qo'shish
          </button>

          <Top />
        </div>
      </div>

      <!-- JADVAL -->
      <div class="expense-table-wrapper">
        <div class="table-scroll-container">
          <table class="expense-table">
            <thead>
              <tr>
                <th style="width: 60px">#</th>
                <th style="width: 15%">SANA</th>
                <th style="width: 20%">KATEGORIYA</th>
                <th style="width: 15%">TO'LOV TURI</th>
                <th style="width: 25%">IZOH</th>
                <th style="width: 15%">SUMMA</th>
                <th style="width: 10%; text-align: center;">AMAL</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in expenses" :key="item.id" @dblclick="openEdit(item)">
                <td><span class="id-badge">{{ item.id }}</span></td>
                <td>{{ formatDate(item.datetime) }}</td>
                <td><span class="cat-badge">{{ getCatName(item.kassa_category_id) }}</span></td>
                <td>{{ getPayName(item.pay_type_id) }}</td>
                <td class="text-muted">{{ item.comment }}</td>
                <td class="sum-text">
                  <span v-if="item.dollar_summa > 0">{{ item.dollar_summa | numFormat }} $</span>
                  <span v-else>{{ item.summa | numFormat }}</span>
                </td>
                <td style="text-align: center;">
                  <div class="row-actions">
                    <button class="icon-btn edit-btn" @click="openEdit(item)" title="Tahrirlash">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M12 20h9"></path>
                        <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
                      </svg>
                    </button>
                    <button class="icon-btn delete-btn" @click="deleteExpense(item.id)" title="O'chirish">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="expenses.length === 0">
                <td colspan="7" class="text-center py-5 text-muted">Ma'lumot mavjud emas</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- FORM MODAL -->
    <XarajatForm
      v-model="showForm"
      :categories="categories"
      :payment-types="paymentTypes"
      :dollar-rate="dollarRate"
      :edit-item="editItem"
      @saved="onSaved"
    />

    <!-- SETTING MODAL -->
    <XarajatSetting
      v-model="showSetting"
      :categories="categories"
      @changed="fetchInitialData"
    />
  </div>
</template>

<script>
import axios from 'axios';
import Top from '../Layout/Top.vue';
import XarajatForm from './Form.vue';
import XarajatSetting from './Setting.vue';

export default {
  name: 'XarajatlarIndex',
  components: { Top, XarajatForm, XarajatSetting },
  data() {
    return {
      dollarRate: 0,
      newRate: null,
      showRateModal: false,
      isSaving: false,

      categories: [],
      paymentTypes: [],
      expenses: [],

      showForm: false,
      showSetting: false,
      editItem: null,
    };
  },
  filters: {
    numFormat(val) {
      return val ? Number(val).toLocaleString().replace(/,/g, ' ') : "0";
    }
  },
  async mounted() {
    await this.fetchInitialData();
    await this.fetchExpenses();
    window.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy() {
    window.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    async fetchInitialData() {
      try {
        const [rateRes, catRes, payRes] = await Promise.all([
          axios.get('/api/v1/dollar-exchange-rate/last'),
          axios.get('/api/v1/kassa-category'),
          axios.get('/api/v1/pay-type')
        ]);
        this.dollarRate = rateRes.data.rate || rateRes.data.amount || 0;
        this.categories = catRes.data.data || catRes.data;
        this.paymentTypes = payRes.data;
      } catch (e) {
        console.error("Init data error:", e);
      }
    },
    async fetchExpenses() {
      try {
        // Faqat xarajatlar (chiqim) — kassaga kirim top-up'lar bu ro'yxatga tushmaydi
        const res = await axios.get('/api/v1/kassa-order', { params: { type: 'chiqim' } });
        this.expenses = Array.isArray(res.data) ? res.data : (res.data.data || []);
      } catch (e) {
        console.error("Expenses fetch error:", e);
      }
    },
    openCreate() {
      this.editItem = null;
      this.showForm = true;
    },
    openEdit(item) {
      this.editItem = { ...item };
      this.showForm = true;
    },
    onSaved() {
      this.fetchExpenses();
    },
    async updateDollarRate() {
      if (!this.newRate || this.isSaving) return;
      this.isSaving = true;
      try {
        await axios.post('/api/v1/dollar-exchange-rate', {
          rate: this.newRate,
          user_id: Number(localStorage.getItem('user_id')),
          sklad_id: Number(localStorage.getItem('sklad_id')),
          datetime: Math.floor(Date.now() / 1000)
        });
        this.dollarRate = this.newRate;
        this.showRateModal = false;
        this.newRate = null;
      } catch (e) {
        alert("Kursni saqlashda xatolik");
      } finally {
        this.isSaving = false;
      }
    },
    async deleteExpense(id) {
      if (!confirm("Haqiqatan ham bu xarajatni o'chirmoqchimisiz?")) return;
      try {
        await axios.delete(`/api/v1/kassa-order/id/${id}`);
        this.expenses = this.expenses.filter(item => item.id !== id);
      } catch (e) {
        alert("O'chirishda xatolik");
      }
    },
    getCatName(id) {
      const f = this.categories.find(c => c.id === id);
      return f ? f.name : '-';
    },
    getPayName(id) {
      const f = this.paymentTypes.find(p => p.id === id);
      return f ? f.name : '-';
    },
    formatDate(ts) {
      if (!ts) return '';
      const d = new Date(ts * 1000);
      return d.toLocaleDateString('ru-RU') + ' ' + d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
    },
    toggleSettings() { this.showRateModal = !this.showRateModal; if (this.showRateModal) this.newRate = null; },
    handleOutsideClick(e) {
      if (this.showRateModal && this.$refs.settingsContainer && !this.$refs.settingsContainer.contains(e.target)) {
        this.showRateModal = false;
      }
    }
  }
};
</script>

<style>
.z-top-modal { z-index: 9999 !important; }
.modal-backdrop.show { z-index: 9990 !important; }
</style>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

.g-page { padding: 30px; background-color: #f8fafc; min-height: 100%; font-family: 'Inter', sans-serif; color: #334155; }
.content-container { max-width: 1200px; margin: 0 auto; }

.header-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; flex-wrap: wrap; gap: 12px; }
.header-right { display: flex; align-items: center; gap: 12px; }
.expenses-title { color: #be185d; font-weight: 800; font-size: 28px; margin: 0; }

.rate-settings-container { position: relative; }
.rate-display { display: flex; align-items: center; gap: 8px; padding: 6px 14px 6px 6px; background: white; border-radius: 999px; box-shadow: 0 2px 8px rgba(0,0,0,.06); cursor: pointer; transition: .2s; }
.rate-display:hover { box-shadow: 0 4px 12px rgba(0,0,0,.1); }
.dollar-circle { width: 30px; height: 30px; border-radius: 50%; background: #10b981; color: white; display: flex; align-items: center; justify-content: center; font-weight: 800; }
.rate-value { font-weight: 700; color: #334155; }

.mini-modal { position: absolute; top: calc(100% + 10px); right: 0; background: white; border-radius: 14px; padding: 14px; box-shadow: 0 12px 32px rgba(0,0,0,.12); z-index: 50; min-width: 240px; }
.modal-arrow { position: absolute; top: -6px; right: 22px; width: 12px; height: 12px; background: white; transform: rotate(45deg); }
.modal-body { position: relative; display: flex; flex-direction: column; gap: 8px; }
.modal-body .modal-title { font-size: 12px; color: #64748b; font-weight: 700; text-transform: uppercase; }
.modal-body input { border: 1px solid #e2e8f0; border-radius: 10px; padding: 8px 12px; outline: none; }
.modal-body input:focus { border-color: #10b981; }
.modal-save-btn { background: #10b981; color: white; border: none; padding: 8px; border-radius: 10px; font-weight: 700; cursor: pointer; }
.modal-save-btn:hover { background: #059669; }
.slide-fade-enter-active, .slide-fade-leave-active { transition: all .2s ease; }
.slide-fade-enter, .slide-fade-leave-to { opacity: 0; transform: translateY(-6px); }

.settings-btn-top, .add-btn-top {
  border: none;
  height: 40px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 16px;
  transition: .2s;
}
.settings-btn-top { background: #f1f5f9; color: #475569; width: 40px; justify-content: center; padding: 0; }
.settings-btn-top:hover { background: #e2e8f0; }
.add-btn-top { background: linear-gradient(135deg, #be185d 0%, #db2777 100%); color: white; box-shadow: 0 4px 15px rgba(190,24,93,.3); padding: 0 22px; }
.add-btn-top:hover { transform: translateY(-1px); }

.expense-table-wrapper { background: white; border-radius: 20px; padding: 6px; box-shadow: 0 10px 30px rgba(0,0,0,.03); border: 1px solid #f1f5f9; }
.table-scroll-container { overflow-x: auto; }
.expense-table { width: 100%; border-collapse: separate; border-spacing: 0; }
.expense-table th { background: white; padding: 14px 15px; color: #94a3b8; font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; border-bottom: 1px solid #f1f5f9; text-align: left; }
.expense-table td { padding: 12px 15px; border-bottom: 1px solid #f8fafc; font-size: 14px; color: #334155; vertical-align: middle; }
.expense-table tbody tr:hover { background: #fdf2f8; }
.id-badge { background: #fce7f3; color: #be185d; padding: 3px 10px; border-radius: 8px; font-weight: 700; font-size: 12px; }
.cat-badge { background: #f3e8ff; color: #7e22ce; padding: 4px 10px; border-radius: 8px; font-size: 12px; font-weight: 700; }
.sum-text { font-weight: 800; color: #be185d; font-variant-numeric: tabular-nums; }

.row-actions { display: flex; gap: 6px; justify-content: center; }
.icon-btn { width: 30px; height: 30px; border-radius: 8px; border: none; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: .15s; }
.edit-btn { background: #eff6ff; color: #2563eb; }
.edit-btn:hover { background: #2563eb; color: white; }
.delete-btn { background: #fff1f2; color: #e11d48; }
.delete-btn:hover { background: #e11d48; color: white; }

.text-muted { color: #94a3b8 !important; }
.text-center { text-align: center; }
.py-5 { padding: 2rem 0; }

@media (max-width: 768px) {
  .g-page { padding: 16px; }
  .header-row { flex-direction: column; align-items: stretch; }
  .header-right { justify-content: flex-end; }
  .expenses-title { font-size: 22px; }
}
</style>
